export const ROLE_LIST_REQUEST = 'ROLE_LIST_REQUEST'
export const ROLE_LIST_SUCCESS = 'ROLE_LIST_SUCCESS'
export const ROLE_LIST_FAIL = 'ROLE_LIST_FAIL'

export const BULK_ACTION_REQUEST = 'BULK_ACTION_REQUEST'
export const BULK_ACTION_SUCCESS = 'BULK_ACTION_SUCCESS'
export const BULK_ACTION_FAIL = 'BULK_ACTION_FAIL'

export const MODULE_LIST_REQUEST = 'MODULE_LIST_REQUEST'
export const MODULE_LIST_SUCCESS = 'MODULE_LIST_SUCCESS'
export const MODULE_LIST_FAIL = 'MODULE_LIST_FAIL'

export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST'
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS'
export const CREATE_ROLE_FAIL = 'CREATE_ROLE_FAIL'

export const DETAIL_ROLE_REQUEST = 'DETAIL_ROLE_REQUEST'
export const DETAIL_ROLE_SUCCESS = 'DETAIL_ROLE_SUCCESS'
export const DETAIL_ROLE_FAIL = 'DETAIL_ROLE_FAIL'

export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST'
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS'
export const UPDATE_ROLE_FAIL = 'UPDATE_ROLE_FAIL'

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST'
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS'
export const DELETE_ROLE_FAIL = 'DELETE_ROLE_FAIL'

export const RESET_STATE_ROLE = 'RESET_STATE_ROLE'
